<script lang="ts">
  import { fly } from 'svelte/transition';

  /* Atoms */
  import type { CourseModel, SessionModel } from '@24hbs/utils';
  import { createEventDispatcher } from 'svelte';
	import { dateShortMonthFormat, isValidDate } from '$lib/utils/formatter';
	import { Icon } from '../Icon';
	import { openModal } from '$lib/utils/modals';
	import { CourseSelectModal } from '$lib/components/organisms/Modal';

  export let session: SessionModel;
  export let enableSessionSelection = false;
  export let sessionOptions: {[idSession: string]: SessionModel};
  export let selectedSession: CourseModel | SessionModel;
  export let hasVatFree: boolean;
  export let showExpandButton: boolean;
  export let onScheduleChange: (e: CustomEvent<{ value: SessionModel }>) => void;

  let isDesktop = typeof window !== 'undefined' ? document.documentElement.clientWidth >= 768 : false;

  const onResize = () => {
    isDesktop = document.documentElement.clientWidth >= 768;
  };

  const openDateSelector = () => {
    if (enableSessionSelection) {
      const promoLabel: HTMLElement = document.querySelector('.timer-label');
      if (promoLabel) {
        // showModal ? promoLabel.style.setProperty('z-index', '50') : promoLabel.style.setProperty('z-index', '80');
        promoLabel.style.setProperty('z-index', '50');
      }
      openModal(CourseSelectModal, {
        session,
        sessionOptions,
        selectedSession,
        hasVatFree,
        showExpandButton,
        onScheduleChange,
      });
    }
  };
</script>

<svelte:window on:resize={onResize} />

<div class="course-select-wrapper">
  <h4 class="course-select-title">Scegli quando partire</h4>
  <button class="course-select" on:click={openDateSelector}>
    {#if isValidDate(session.startDate)}
      {#if session.lessonsAvailableImmediately}
        Lezioni disponibili da subito
      {:else}
        <span class="course-select-text">
          DAL {dateShortMonthFormat(session.startDate).toUpperCase()} AL {dateShortMonthFormat(session.endDate).toUpperCase()}
        </span>
      {/if}
      <span class="course-select-icon"><Icon icon="chevronDown" /></span>
    {:else}
      <span class="course-select-text"> ON DEMAND </span>
    {/if}
  </button>
</div>

<style type="text/scss" lang="scss" scoped>
  .course-select-title {
    @apply font-sans font-semibold text-sm md:text-base;
    @apply uppercase tracking-wider text-gray-600;
    @apply md:hidden;
    @apply mb-3 md:mb-0;
  }

  .course-select {
    @apply appearance-none;
    @apply w-full h-12;
    @apply flex flex-nowrap items-center justify-between;
    @apply bg-white;
    @apply px-4 m-0;
    @apply cursor-pointer;
    @apply border border-current rounded;

    @apply focus:ring-2 focus:ring-brand focus:outline-none;
  }

  .course-select-text {
    @apply uppercase tracking-wide text-sm text-gray-900;
    @apply truncate;
  }

  .course-select-icon {
    @apply inline-flex;
    @apply ml-2;
  }
</style>
